import React from 'react';

import { Box } from '@atlaskit/primitives/compiled';

import { Rule } from './rule';
import { type Props } from './types';

export const Rules = ({ rules }: Props) => {
	return (
		<Box>
			{rules
				.sort((a, b) => a.time - b.time)
				.map((rule, index) => (
					<Rule rule={rule} key={`${index}-${rule.type}-${rule.notifyId}`} />
				))}
		</Box>
	);
};
